export default "__VITE_ASSET__CzEaISSq__"